var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "header" } }, [
    _c("a", { attrs: { href: _vm.cmlUrl } }, [
      _c("img", {
        attrs: { id: "logo", src: require("../../images/cml-logo.png") },
      }),
    ]),
    _vm._v(" "),
    _c("h1", { staticClass: "font-weight-bolder" }, [
      _vm._v("Teacher Collections Request"),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }